import { UserRolesEnum } from "../enums";

export function isAdminRole(userRole?: UserRolesEnum): boolean {
	return userRole === UserRolesEnum.Admin || userRole === UserRolesEnum.SubAdmin;
}

export function isSubAdminRole(userRole?: UserRolesEnum): boolean {
	return userRole === UserRolesEnum.SubAdmin;
}

export function isSuperAdminRole(userRole?: UserRolesEnum): boolean {
	return userRole === UserRolesEnum.Admin;
}
